import { Component, signal } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';

import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { TracksManagerStore } from '@data-access/manager/stores/tracks-manager.store';
import { CarouselImagesStore } from '@data-access/manager/stores/carousel-manager.store';
import { ApplicationStore } from '@data-access/user/stores/application.store';



@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterModule,
    RouterOutlet,

    MainLayoutComponent,
  ],
  providers: [
    TracksManagerStore,
    CarouselImagesStore,
    ApplicationStore,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('djlab-app');
}
